import { createContext } from "react";

export const AuthContext = createContext({
    isLoggedIn: false,
    token: null,
    login: () => { },
    logout: () => { },
    username: null,
    password: null,
    data: null,
    update: null
});
